<template>
    <div class="container">
        <div class="comment_form">
            <h6>Deja un Comentario</h6>
            <form action="#">
                <div class="form-group">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Nombre"
                    />
                </div>
                <div class="form-group">
                    <input
                        type="email"
                        class="form-control"
                        placeholder="Correo electrónico"
                    />
                </div>
                <div class="form-group">
                    <textarea
                        rows="5"
                        class="form-control"
                        placeholder="Comentario"
                    ></textarea>
                </div>
                <div class="form-group">
                    <input
                        type="submit"
                        class="btn"
                        value="Enviar Comentario"
                    />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
